import { render, staticRenderFns } from "./Vordesk.vue?vue&type=template&id=58668440&scoped=true&"
import script from "./Vordesk.vue?vue&type=script&lang=js&"
export * from "./Vordesk.vue?vue&type=script&lang=js&"
import style0 from "./Vordesk.vue?vue&type=style&index=0&id=58668440&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58668440",
  null
  
)

export default component.exports